import { useEffect, useState } from 'react';
import { useAuthenticationDataContext } from '../../Helpers/AuthenticationDataProvider';
import useFetchWrapper, { HttpResponse } from '../../Helpers/useFetchWrapper';
import { ResourceStatistics, StatisticsDisplay, UserStatistics } from './Statistics.model';

export const useStatistics = () => {

	const [resourceStatistics, setResourceStatistics] = useState<ResourceStatistics>();
	const [userStatistics, setUserStatistics] = useState<UserStatistics>();
	const [showExportPopup, setShowExportPopup] = useState(false);
	const { get, post } = useFetchWrapper();

	const { email } = useAuthenticationDataContext();


	const resourceStatisticsInfo: StatisticsDisplay[] = [

		{
			icon: { name: 'books', type: 'solid' },
			label: 'statistics.nrOfResources',
			value: resourceStatistics?.noOfResources,
		},
		{
			icon: { name: 'download', type: 'solid' },
			label: 'statistics.nrOfDownloads',
			value: resourceStatistics?.noOfDownloads,
		},
		{
			icon: { name: 'video', type: 'solid' },
			label: 'statistics.nrOfVideos',
			value: resourceStatistics?.noOfVideos,
		},
		{
			icon: { name: 'microphone', type: 'solid' },
			label: 'statistics.nrOfAudio',
			value: resourceStatistics?.noOfAudios,
		},
		{
			icon: { name: 'file-alt', type: 'solid' },
			label: 'statistics.nrOfTextDocuments',
			value: resourceStatistics?.noOfTexts,
		},
	];

	const userStatisticsInfo: StatisticsDisplay[] = [

		{
			icon: { name: 'user-friends', type: 'solid' },
			label: 'statistics.nrOfMentors',
			value: userStatistics?.nrOfMentors,
		},
		{
			icon: { name: 'users', type: 'solid' },
			label: 'statistics.nrOfMentees',
			value: userStatistics?.nrOfMentees,
		},
		{
			icon: { name: 'user-plus', type: 'solid' },
			label: 'statistics.nrOfPendingApplications',
			value: userStatistics?.nrOfPendingApplications,
		},
		{
			icon: { name: 'user-times', type: 'solid' },
			label: 'statistics.nrOfRejectedApplications',
			value: userStatistics?.nrOfRejectedApplications,
		},
		{
			icon: { name: 'comment-alt-edit', type: 'solid' },
			label: 'statistics.nrOfGeneralFeedback',
			value: userStatistics?.nrOfGeneralFeedbacks,
		},
		{
			icon: { name: 'life-ring', type: 'solid' },
			label: 'statistics.nrOfHelpRequests',
			value: userStatistics?.nrOfHelpRequests,
		},
		{
			icon: { name: 'bug', type: 'solid' },
			label: 'statistics.nrOfBugReportFeedbacks',
			value: userStatistics?.nrOfBugReportFeedbacks,
		},
		{
			icon: { name: 'comment-alt', type: 'solid' },
			label: 'statistics.nrOfComments',
			value: userStatistics?.nrOfComments,
		},
		{
			icon: { name: 'flag', type: 'solid' },
			label: 'statistics.nrOfAbuseComplaints',
			value: userStatistics?.nrOfAbuseComplaints,
		},
		{
			icon: { name: 'users-class', type: 'solid' },
			label: 'statistics.nrOfApplicantMentees',
			value: userStatistics?.nrOfApplicantMentees,
		},
	];

	const getResourceStatistics = async () => {
		const response: HttpResponse<ResourceStatistics> = await get('/resource/statistics');
		response.parsedBody && setResourceStatistics(response.parsedBody);
	};

	const getUserStatistics = async () => {
		const response: HttpResponse<UserStatistics> = await get('/user/statistics');
		response.parsedBody && setUserStatistics(response.parsedBody);
	};

	const exportResourceStatistics = async () => {
		const response = await get('/resource/export-statistics');
		if (response.status === 200) toggleExportPopup();
	}

	const exportUserStatistics = async () => {
		const response = await get('/user/export-statistics');
		if (response.status === 200) toggleExportPopup();
	}

	const toggleExportPopup = () => {
		setShowExportPopup(value => !value);
	}

	useEffect(() => {
		getResourceStatistics();
		getUserStatistics();
	}, []);
	
	return {
		exportResourceStatistics,
		exportUserStatistics,
		state: {
			email,
			resourceStatistics,
			resourceStatisticsInfo,
			showExportPopup,
			userStatistics,
			userStatisticsInfo,
		},
		toggleExportPopup
	};
};
